import { render, staticRenderFns } from "./SummaryCardBodyItem.vue?vue&type=template&id=479b7c91&"
import script from "./SummaryCardBodyItem.vue?vue&type=script&lang=js&"
export * from "./SummaryCardBodyItem.vue?vue&type=script&lang=js&"
import style0 from "./SummaryCardBodyItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports